var map = {
	"./Stroke 1.png": 1080,
	"./Why Our Save the Dat.png": 1081,
	"./all_about_shipping@2x.png": 1082,
	"./ask_for_everything@2x.png": 1083,
	"./big-day@1x.png": 588,
	"./big-day@2x.png": 589,
	"./birds@1x.png": 1084,
	"./birds@2x.png": 1085,
	"./check-list@1x.png": 614,
	"./check-list@2x.png": 615,
	"./circle-better@1x.png": 1086,
	"./circle-better@2x.png": 1087,
	"./empty_rsvp.png": 1088,
	"./empty_rsvp2x.png": 1089,
	"./envelope.png": 616,
	"./envelope.svg": 1090,
	"./envelope@2x.png": 1091,
	"./events_doodle.png": 275,
	"./events_doodle.svg": 1092,
	"./gifts@1x.png": 1093,
	"./gifts@2x.png": 1094,
	"./guest-list@1x.png": 577,
	"./guest-list@2x.png": 578,
	"./guest.png": 1095,
	"./guest.svg": 1096,
	"./guest2x.png": 1097,
	"./guest_approved@2x.png": 1098,
	"./invitations@1x.png": 590,
	"./invitations@2x.png": 591,
	"./invites_paper.svg": 1099,
	"./invites_paper@1x.png": 617,
	"./invites_paper@2x.png": 618,
	"./laptop-one-heart.png": 1100,
	"./laptop-one-heart@2x.png": 1101,
	"./laptop@1x.png": 1102,
	"./laptop@2x.png": 1103,
	"./long-page-checklist.png": 1104,
	"./long-page-checklist@2x.png": 1105,
	"./make_it_personal@2x.png": 1106,
	"./namecard-with-name.png": 1107,
	"./namecard-with-name@2x.png": 1108,
	"./namecard_no_name.svg": 473,
	"./namecard_with_name.svg": 1109,
	"./namecard_with_question_marks.svg": 138,
	"./no_address.png": 1110,
	"./no_address2x.png": 1111,
	"./onboarding_1.png": 474,
	"./onboarding_1@2x.png": 475,
	"./onboarding_2.png": 1112,
	"./onboarding_2@2x.png": 1113,
	"./onboarding_3.png": 476,
	"./onboarding_3@2x.png": 477,
	"./onboarding_4.png": 1114,
	"./onboarding_4@2x.png": 1115,
	"./red-star-left@1x.png": 579,
	"./red-star-left@2x.png": 580,
	"./red-star-right@1x.png": 581,
	"./red-star-right@2x.png": 582,
	"./registry_publish_champagne.svg": 1116,
	"./rsvp@1x.png": 592,
	"./rsvp@2x.png": 593,
	"./save-the-date@1x.png": 594,
	"./save-the-date@2x.png": 595,
	"./sparkle-left.svg": 583,
	"./sparkle-right.svg": 584,
	"./sparkle-up.svg": 619,
	"./ta-da.png": 1117,
	"./ta-da@2x.png": 1118,
	"./talk.svg": 1119,
	"./talk@1x.png": 596,
	"./talk@2x.png": 597,
	"./timeline-line-dark@1x.png": 598,
	"./timeline-line-dark@2x.png": 599,
	"./timeline-line@1x.png": 1120,
	"./timeline-line@2x.png": 1121,
	"./tips.svg": 1122,
	"./underline_long@1x.png": 564,
	"./underline_long@2x.png": 565,
	"./underline_sm@1x.png": 572,
	"./underline_sm@2x.png": 573,
	"./website_publish_confetti.svg": 478,
	"./wedding-websites@1x.png": 620,
	"./wedding-websites@2x.png": 621,
	"./wedding_help.png": 622,
	"./wedding_help.svg": 1123,
	"./wedding_help@2x.png": 1124
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 274;


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/doodles nonrecursive \.(jpg|jpeg|png|gif|svg)(\?.*)?$
// module id = 274
// module chunks = 50